/** Real pipeline stages — keep in sync with `atest.Logic/Helpers/UnitCreationStages/UnitCreationStageLabels.cs`. */
export const UNIT_CREATION_PIPELINE_STAGE_LABELS = [
    'Topic evaluation',
    'Defining lesson structure',
    'Creating worksheets and readings',
    'Selecting videos and photos',
    'Defining diagrams',
    'Defining detailed instructions for teachers'
] as const;

/** UI-only final step shown after the server finishes, before the wait dialog closes. */
export const UNIT_CREATION_FINISHING_STEP_LABEL = 'Starting image generation';

/** How long the UI-only finishing step stays visible before the dialog closes. */
export const UNIT_CREATION_FINISHING_STEP_MS = 2000;

/** Pipeline stages plus the UI-only finishing step for the wait loader. */
export const UNIT_CREATION_STAGE_LABELS = [
    ...UNIT_CREATION_PIPELINE_STAGE_LABELS,
    UNIT_CREATION_FINISHING_STEP_LABEL
] as const;

const STAGE_KEY_TO_INDEX: Record<string, number> = {
    TopicEvaluation: 0,
    DefiningLessonStructure: 1,
    CreatingWorksheetsAndReadings: 2,
    SelectingVideosAndImages: 3,
    CreatingDiagrams: 4,
    DefiningDetailedInstructions: 5
};

/** Maps a progress label or stage key from E335 to a monotonic stage index. */
export function labelToStageIndex(label: string): number {
    const trimmed = label.trim();
    if (!trimmed) return -1;

    const byLabel = UNIT_CREATION_STAGE_LABELS.findIndex(
        stage => stage.toLowerCase() === trimmed.toLowerCase()
    );
    if (byLabel >= 0) return byLabel;

    const byKey = STAGE_KEY_TO_INDEX[trimmed];
    return typeof byKey === 'number' ? byKey : -1;
}
